export { default as signCertificataService } from './sign.certificata.service';
